import { ReactComponent as OutlineChevronLeft } from "assets/svg/outline-chevron-left.svg";
import { ReactComponent as OutlineChevronRight } from "assets/svg/outline-chevron-right.svg";
import IconButton from "components/icon-button";
import { useUser } from "contexts/UserContext";
import { usePhonePortraitContext } from "contexts/phone-portrait-context";
import { useTimeOnPageContext } from "contexts/time-on-page";
import messages from "messages";
import moment from "moment-timezone";
import { Fragment, useEffect, useMemo } from "react";
import { ButtonGroup } from "react-bootstrap";
import Button from "react-bootstrap/esm/Button";
import { useDispatch } from "react-redux";
import { closeSidesheet } from "store/calendarSidebarSlice";
import { AmplitudePageName, track } from "utils/amplitude";
import getClasses from "utils/getClasses";
import {
  TIME_RANGE_TYPE,
  useCalendarTime,
} from "../../../../contexts/CalendarTimeContext";
import CreateSession from "../../components/create-session";
import { getTimeRangeText } from "../../utils/getTimeRangeText";
import styles from "./CalendarHeader.module.scss";

const ANALYTICS_PAGE_NAME: AmplitudePageName = "pro-calendar";

const CalendarHeader = () => {
  const dispatch = useDispatch();
  const { isPhonePortrait } = usePhonePortraitContext();
  const {
    onChangeTimeRange,
    currentTimeRangeType,
    setCurrentTimeRangeType,
    anchorTime,
    setAnchorTime,
    timeRange,
    currentCalendarTimezone,
  } = useCalendarTime();
  const { user } = useUser();
  const todayValue = useMemo(
    () => moment().tz(currentCalendarTimezone).startOf("day").valueOf(),
    [currentCalendarTimezone],
  );

  const { setPage } = useTimeOnPageContext();
  useEffect(() => {
    setPage(ANALYTICS_PAGE_NAME);
  }, [setPage]);

  useEffect(
    () => () => {
      dispatch(closeSidesheet());
    },
    [dispatch],
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles["calendar-header"]}>
      {/* time range controls */}
      <div className={styles["time-control-container"]}>
        <div className={styles["header-time"]}>
          {/* change type */}
          <ButtonGroup aria-label="calendar-button-group">
            {(["day", "week", "month"] as TIME_RANGE_TYPE[]).map(
              (timeRangeType) => (
                // <OverlayTrigger
                //   placement="bottom"
                //   overlay={
                //     <Tooltip id="button-tooltip">
                //       {messages[el]} [{messages[el].slice(0, 1)}]
                //     </Tooltip>
                //   }
                //   key={timeRangeType}
                // >
                <Button
                  key={timeRangeType}
                  variant="outline-primary"
                  className={getClasses(
                    currentTimeRangeType === timeRangeType &&
                      styles["button--selected"],
                    styles["button"],
                  )}
                  onClick={() => {
                    track(
                      ANALYTICS_PAGE_NAME,
                      `${timeRangeType}-time-range-button`,
                      "click",
                    );
                    setCurrentTimeRangeType(timeRangeType);
                  }}
                >
                  {messages[timeRangeType]}
                </Button>
                // </OverlayTrigger>
              ),
            )}
          </ButtonGroup>
          {/* <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="button-tooltip">Today [T]</Tooltip>}
                    > */}
          <Button
            variant={"outline-primary"}
            className={styles["today"]}
            onClick={() => {
              track(ANALYTICS_PAGE_NAME, "today-button", "click");
              setAnchorTime && setAnchorTime(todayValue);
            }}
          >
            {"Today"}
          </Button>
          {/* </OverlayTrigger> */}
          <IconButton
            onClick={() => {
              track(ANALYTICS_PAGE_NAME, "time-range-left-arrow", "click");
              onChangeTimeRange(-1);
            }}
          >
            <OutlineChevronLeft className={"ml-2"} />
          </IconButton>
          <IconButton
            onClick={() => {
              track(ANALYTICS_PAGE_NAME, "time-range-right-arrow", "click");
              onChangeTimeRange(1);
            }}
          >
            <OutlineChevronRight />
          </IconButton>
          <span
            className={
              !isPhonePortrait
                ? styles["header-time-title"]
                : styles["header-time-title--phone"]
            }
          >
            {getTimeRangeText({
              anchorTime,
              timeRange,
              type: currentTimeRangeType,
              timezone: currentCalendarTimezone,
            }).map(({ date, year }, i) => (
              <Fragment key={i}>
                <span>
                  {i > 0 ? " - " : ""}
                  {date}
                </span>
                {year && (
                  <span className={styles["header-time-title-year"]}>
                    {" " + year}
                  </span>
                )}
              </Fragment>
            ))}
          </span>
        </div>
      </div>
      <div
        className={getClasses(
          styles["view-control-container"],
          "d-flex align-items-center py-3",
        )}
      >
        {/* <ChangeView
                  view={selectedViewStateId}
                  onApply={setSelectedViewStateId}
                /> */}
        <CreateSession
          timezone={currentCalendarTimezone}
          user={user}
          analyticsPageName={ANALYTICS_PAGE_NAME}
        />
      </div>
    </div>
  );
};

export default CalendarHeader;
